const SEARCH_API = `/search/instantsearch/instant`;

export const Search = QUERY => {
    const URL = QUERY ? `${SEARCH_API}?key=${QUERY}` : SEARCH_API;
    return fetch(URL, { credentials: 'include' })
        .then(response => {
            return response.text();
        }).catch(err => {
            return { message: 'server error', err };
        });
};